import React from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import pure from 'recompose/pure';
import setDisplayName from 'recompose/setDisplayName';
import CanvasHoverMap from './controls/Map';

export const map = ({
    style,
    options,
    hoverDistance,
    renderMarkers,
    mapParams: { zoom, center },
    onMapParamsChange,
    ...props
}) => (
    <CanvasHoverMap
        {...props}
        // flex: 1 here
        style={style}
        // google map options https://developers.google.com/maps/documentation/javascript/controls#ControlOptions
        options={options}
        // see CanvasMap onMouseMove, distance at which algorithm decides that marker is hovered
        hoverDistance={hoverDistance}
        // google-map-react props
        center={center}
        zoom={zoom}
        onChange={onMapParamsChange}
        // render markers at canvas
        renderMarkers={renderMarkers}
        // render hovered marker as is
        // to force redraw just pass a new empty object to refresh for example
        // refresh={selected}
    />
);

export const canvasMapHOC = compose(
    pure,
    defaultProps({
        draggable: true,
        options: {
            scrollwheel: true,
            zoomControl: true,
            zoomControlOptions: {
                position: 1 // google.maps.ControlPosition.LEFT_TOP
            },
            minZoom: 3,
            zoom: 10,
            maxZoom: 18,
            disableDoubleClickZoom: true
        },
        style: {
            flex: 1
        },
        hoverDistance: 30
    }),
    withState('mapParams', 'setMapParams', props => {
        return { center: props.defaultCenter, zoom: props.defaultZoom };
    }),
    withHandlers({
        onMapParamsChange: ({ onChange, setMapParams }) => (...args) => {
            const [{ center, zoom, bounds }] = args;
            onChange && onChange(...args);
            setMapParams({ center, zoom, bounds });
        },
        // be sure in current implementation markers is tile markers, not all markers.
        // tiling is used as it allows some perf optimizations not used here
        renderMarkers: () => ({ ctx, markers, tileSize }) => {
            ctx.clearRect(0, 0, tileSize, tileSize);
            markers.forEach(({ x, y, props }) => {
                const { drawOnCanvas } = props;
                if (typeof drawOnCanvas === 'undefined') {
                    throw new Error(
                        'drawOnCanvas function should be passed in order to be drawn on canvas'
                    );
                }
                drawOnCanvas({ ctx, x, y, props });
            });
        }
    })
);

const BaseCanvasMap = canvasMapHOC(map);
setDisplayName('BaseCanvasMap')(BaseCanvasMap);
export default BaseCanvasMap;
